import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/app";
import deltas from "../../actions/deltas";

const {SET_APP_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.LOGGED_OUT, SET_APP_STATE);
